import { Component, FC, ReactNode } from "react";

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback: FC<{ error: Error | null }>;
};
type ErrorBoundaryState = { error: Error | null };

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      error: null,
    };
  }
  static getDerivedStateFromError(error: Error) {
    return {
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Caught error", error, errorInfo);
  }

  render() {
    const Fallback = this.props.fallback;

    if (this.state.error) {
      return <Fallback error={this.state.error} />;
    }

    return this.props.children;
  }
}
